import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { WorkflowsLoader } from '@confluence/advanced-workflows/entry-points/Workflows';

export const AdminWorkflowsRoute = () => <WorkflowsLoader />;

AdminWorkflowsRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'workflowsAdminScreen' },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
